import './InviteAdmins.scss'

import React from 'react'
import { connect } from 'react-redux'
import {show as showModal} from 'redux-modal'

import OpButton from 'common/views/components/OpButton'
import AddAdminRow from './AddAdminRow'
import UserCogIcon from './UserCogIcon'

import { addAdminInvite, postAdminInvites } from 'broker/redux/manage_users'
import { selectAdminInvites, selectAdminInvitesCount, selectAdminFormErrors, selectIsSendingAdminInvites } from 'broker/selectors/manage_users'

import { segmentEventTracker } from 'common/analytics'

const MANUAL_SEGMENT_PAGE = 'invite-admins'

const InviteAdmins = (props) => {
  const { handleBack, invites, count, addInvite, formErrors, postAdminInvites, sendingInvites } = props

  return (
    <div className="InviteAdmins">
      <span className="back-button" onClick={handleBack}>{'< Back'}</span>
      <div className="InviteAdmins--body">
        { /******* HEADING SECTION *******/}
        <div className="heading-wrapper">
          <div className="heading">
            <div className="-icon"><UserCogIcon/></div>
            <div className="-title">Invite Broker Portal Admins</div>
          </div>
          <div className="heading-details-row">
            <div className="left-col">
              <div className="admin-invite-count">{`Invite Admins (${count})`}</div>
            </div>
            <div className="right-col">
              <OpButton
                bsStyle="primary-green"
                disabled={!count || formErrors}
                onClick={postAdminInvites}
                pending={sendingInvites}
              >
                Invite admins
              </OpButton>
            </div>
          </div>
        </div>

        <div>
          {_.map(invites, i => <AddAdminRow invite={i} key={i.key} />)}
        </div>
        <div className="add-admin-button" onClick={() => {
          addInvite()

          segmentEventTracker('User Added', {
            'was_bulk': false,
            'user_type': 'broker_admin',
            'from_search': false,
            'amount_added': 1
          }, null, MANUAL_SEGMENT_PAGE)
        }}>
          <i className="fa fa-plus-circle" style={{fontSize: 20}}/> Add another admin
        </div>

      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  invites: selectAdminInvites(state),
  count: selectAdminInvitesCount(state),
  formErrors: selectAdminFormErrors(state),
  sendingInvites: selectIsSendingAdminInvites(state)
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  showModal: name => dispatch(showModal(name)),
  addInvite: body => dispatch(addAdminInvite(body)),
  postAdminInvites: () => dispatch(postAdminInvites())
})

export default connect(mapStateToProps, mapDispatchToProps)(InviteAdmins)
